export default "__VITE_ASSET__d0vsaepC5HwMNT2$z9p2Ug__"